import { IAppState } from '../../redux';

export const selectCanPayByCard = (state: IAppState): boolean => {
  return !!state.user.canPayByCard;
};
